/* eslint-disable unicorn/no-thenable */
const schema = {
  type: 'object',
  required: ['name', 'isVirtualStateSet'],
  properties: {
    name: {
      type: 'string',
      title: 'State set name',
    },
    isVirtualStateSet: {
      type: 'boolean',
      title: 'Virtual component',
      default: false,
    },
  },
  dependencies: {
    isVirtualStateSet: {
      oneOf: [
        {
          properties: {
            isVirtualStateSet: {
              enum: [true],
            },
            states: {
              title: 'state',
              type: 'object',
              required: ['name', 'text', 'color', 'description'],
              properties: {
                name: {
                  type: 'string',
                  title: 'State name',
                },
                text: {
                  type: 'string',
                  title: 'Text',
                },
                description: {
                  type: 'string',
                  title: 'Description / Suggestion',
                },
                color: {
                  type: 'string',
                  title: 'Color',
                  inputType: 'color',
                  default: '#3366ff',
                },
              },
            },
          },
        },
        {
          properties: {
            isVirtualStateSet: {
              enum: [false],
            },
            states: {
              title: 'states',
              type: 'array',
              minItems: 1,
              items: {
                type: 'object',
                required: ['name', 'text', 'color', 'description', 'trigger'],
                properties: {
                  name: {
                    type: 'string',
                    title: 'State name',
                  },
                  text: {
                    type: 'string',
                    title: 'Text',
                  },
                  description: {
                    type: 'string',
                    title: 'Description / Suggestion',
                  },
                  color: {
                    type: 'string',
                    title: 'Color',
                    inputType: 'color',
                    default: '#3366ff',
                  },
                  trigger: {
                    $ref: '#/definitions/trigger',
                  },
                },
              },
            },
          },
        },
      ],
    },
  },
  definitions: {
    trigger: {
      title: '',
      type: 'object',
      properties: {
        condition: {
          title: 'Trigger condition',
          type: 'string',
          default: '=',
          oneOf: [
            { enum: ['='], title: 'equal =' },
            { enum: ['<>'], title: 'between <>' },
            { enum: ['>'], title: 'greater than >' },
            { enum: ['<'], title: 'less than <' },
            { enum: ['<='], title: 'less than or equal to <=' },
            { enum: ['>='], title: 'greater than or equal to >=' },
          ],
        },
      },
      allOf: [
        {
          if: {
            properties: {
              condition: {
                enum: ['<>'],
              },
            },
            required: ['condition'],
          },
          then: {
            required: ['triggerValue1', 'triggerValue2', 'condition'],
            properties: {
              triggerValue1: {
                type: 'number',
                title: 'Trigger start value',
              },
              triggerValue2: {
                type: 'number',
                title: 'Trigger end value',
              },
            },
          },
          else: {
            required: ['triggerValue', 'condition'],
            properties: {
              triggerValue: {
                type: 'number',
                title: 'Trigger value',
              },
            },
          },
        },
      ],
    },
  },
};

const uiSchema = (s) => {
  const hasType = s
    ? {
        isVirtualStateSet: { 'ui:widget': 'hidden' },
      }
    : null;

  return {
    ...hasType,
    definitions: {
      'ui:options': {
        addable: false,
      },
    },
  };
};

export { uiSchema, schema };
